var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4336 32.4712C33.5698 29.4682 29.4669 26.25 21.0801 26.25C12.6932 26.25 8.59294 29.4656 6.72656 32.4712C8.44615 34.627 10.6297 36.3673 13.1148 37.5625C15.5999 38.7578 18.3225 39.3773 21.0801 39.375C23.8376 39.3773 26.5603 38.7578 29.0453 37.5625C31.5304 36.3673 33.714 34.627 35.4336 32.4712Z",
    fill: "#F68D10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 23.625C23.0886 23.625 25.0916 22.7953 26.5685 21.3185C28.0453 19.8416 28.875 17.8386 28.875 15.75C28.875 13.6614 28.0453 11.6584 26.5685 10.1815C25.0916 8.70469 23.0886 7.875 21 7.875C18.9114 7.875 16.9084 8.70469 15.4315 10.1815C13.9547 11.6584 13.125 13.6614 13.125 15.75C13.125 17.8386 13.9547 19.8416 15.4315 21.3185C16.9084 22.7953 18.9114 23.625 21 23.625Z",
    fill: "#F68D10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2.625C16.1266 2.625 11.4529 4.56093 8.00691 8.00691C4.56093 11.4529 2.625 16.1266 2.625 21C2.625 25.8734 4.56093 30.5471 8.00691 33.9931C11.4529 37.4391 16.1266 39.375 21 39.375C25.8734 39.375 30.5471 37.4391 33.9931 33.9931C37.4391 30.5471 39.375 25.8734 39.375 21C39.375 16.1266 37.4391 11.4529 33.9931 8.00691C30.5471 4.56093 25.8734 2.625 21 2.625ZM0 21C0 15.4305 2.21249 10.089 6.15076 6.15076C10.089 2.21249 15.4305 0 21 0C26.5695 0 31.911 2.21249 35.8492 6.15076C39.7875 10.089 42 15.4305 42 21C42 26.5695 39.7875 31.911 35.8492 35.8492C31.911 39.7875 26.5695 42 21 42C15.4305 42 10.089 39.7875 6.15076 35.8492C2.21249 31.911 0 26.5695 0 21Z",
    fill: "#F68D10"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.fcab9c38738e053c6313ec514e4d17b1.svg";
export { ForwardRef as ReactComponent };